export default __webpack_public_path__ + "static/media/Flag of Falkland Islands.6cb9235b.gif";